export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '30px',
        width: '100%',
        margin: '0 auto 2rem',
    },
    inputsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
    },
    validationError: {
        position: 'absolute',
    },
};
